import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';

import { whiteListedCarriers } from './white-listed-carriers';
import { excludedCarriers } from './excluded-carriers';

export const useActiveCarriers = () => {
  const carriers = useSelector(Global.selectReferenceDatagetAllTheCarriers);
  const labelProviders = useSelector(Global.selectReferenceDatagetProviders);
  const carrierIdsForActiveLabelProviders = labelProviders.map((provider) => provider.carrierId);
  return carriers.filter((carrier) => {
    return (
      carrier.active ||
      (!carrier.active && carrierIdsForActiveLabelProviders.includes(carrier.carrierId)) ||
      whiteListedCarriers.includes(carrier.carrierId)
    );
  });
};

export const useMarkAsShippedCarriers = () => {
  const carriers = useActiveCarriers();
  return carriers.filter((carrier) => {
    return !excludedCarriers.includes(carrier.carrierId);
  });
};
